// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1-zjJ","label":"Labeled_label__3M0wP","divider":"Labeled_divider__3j9Ph"};